export const DYNAMIC_TABLE_DATA_ELEMENT = '[data-element="dynamic-table"]';

// CLASSES
export const COMPONENT_CLASS = 'at-dynamic-table';
export const SHADOW_CLASS = `${COMPONENT_CLASS}__shadow`;
export const SHADOW_EARLIER_CLASS = `${SHADOW_CLASS}-earlier`;
export const SHADOW_LATER_CLASS = `${SHADOW_CLASS}-later`;
export const SHADOW_BETWEEN_CLASS = `${SHADOW_CLASS}-between`;

// SELECTORS
export const TABLE_SELECTOR = '.at-table';
export const TABLE_CONTAINER_SELECTOR = '.table-container';
export const COMPONENT_SELECTOR = `.${COMPONENT_CLASS}`;
export const NAVIGATION_SELECTOR = `${COMPONENT_SELECTOR}__navigation`;
export const NAVIGATION_PREV_BUTTON_SELECTOR = `${COMPONENT_SELECTOR}__navigation-prev`;
export const NAVIGATION_NEXT_BUTTON_SELECTOR = `${COMPONENT_SELECTOR}__navigation-next`;
export const HEADER_TITLE_SELECTOR = `${COMPONENT_SELECTOR}__header-title`;

export const HEADER_CELL_TAG = 'thead th';
export const BODY_ROW_TAG = 'tbody tr';

export const SCREENSIZE_SM = 640;
export const SWIPE_THRESHOLD = 50;